export const forecastData = [
  { time: '00:00', forecast: 0, fact: 0 },
  { time: '01:00', forecast: 0, fact: 0 },
  { time: '02:00', forecast: 0, fact: 0 },
  { time: '03:00', forecast: 0, fact: 0 },
  { time: '04:00', forecast: 0, fact: 0 },
  { time: '05:00', forecast: 0, fact: 0 },
  { time: '06:00', forecast: 0, fact: 0 },
  { time: '07:00', forecast: 0, fact: 0 },
  { time: '08:00', forecast: 0, fact: 0 },
  { time: '09:00', forecast: 0, fact: 0 },
  { time: '10:00', forecast: 0, fact: 0 },
  { time: '11:00', forecast: 0, fact: 0 },
  { time: '12:00', forecast: 0, fact: 0 },
  { time: '13:00', forecast: 0, fact: 0 },
  { time: '14:00', forecast: 0, fact: 0 },
  { time: '15:00', forecast: 0, fact: 0 },
  { time: '16:00', forecast: 0, fact: 0 },
  { time: '17:00', forecast: 0, fact: 0 },
  { time: '18:00', forecast: 0, fact: 0 },
  { time: '19:00', forecast: 0, fact: 0 },
  { time: '20:00', forecast: 0, fact: 0 },
  { time: '21:00', forecast: 0, fact: 0 },
  { time: '22:00', forecast: 0, fact: 0 },
  { time: '23:00', forecast: 0, fact: 0 },
];

export const inboxItems: {
  id: number;
  icon: string;
  title: string;
  subtitle: string;
  time: string;
  unread: boolean;
  type: string;
}[] = [];

export const alerts: {
  id: number;
  severity: string;
  title: string;
  detail: string;
  time: string;
  code: string;
}[] = [];

export const dispatchTasks: {
  id: number;
  status: string;
  title: string;
  deadline: string;
  priority: string;
}[] = [];

export const kpiData = [
  { label: 'ВИРОБІТОК', value: '—', unit: 'МВт·г', change: '', positive: true, sub: 'Очікує фактичні дані' },
  { label: 'ДОХІД', value: '—', unit: 'UAH', change: '', positive: true, sub: 'Не підключено' },
  { label: 'ІМБАЛАНС', value: '—%', unit: '', change: '', positive: true, sub: 'Не підключено' },
  { label: 'MAPE', value: '—%', unit: '', change: '', positive: true, sub: 'Очікує факт' },
];

export const modules = [
  { id: 'core', name: 'Core', price: '€15/user', status: 'active', desc: 'Базова платформа, Inbox, документи', trial: false, badge: null },
  { id: 'forecast', name: 'Forecast', price: '€120/station', status: 'active', desc: 'ML-прогноз генерації з точністю 94%', trial: false, badge: 'LIVE' },
  { id: 'bess', name: 'BESS', price: '€350/MW', status: 'trial', desc: 'Управління накопичувачами енергії', trial: true, badge: 'TRIAL' },
  { id: 'dispatch', name: 'Dispatch', price: '€250/station', status: 'active', desc: 'Диспетчеризація та подача MMS', trial: false, badge: null },
  { id: 'reports', name: 'Reports', price: '€100/company', status: 'active', desc: 'Звіти, аналітика, експорт PDF/XLSX', trial: false, badge: null },
  { id: 'ops', name: 'HeliosOps', price: '€150/MW', status: 'locked', desc: 'Операційний моніторинг та O&M', trial: false, badge: 'NEW' },
  { id: 'monitor', name: 'Monitor', price: '€80/station', status: 'locked', desc: 'Real-time SCADA дашборд', trial: false, badge: 'NEW' },
  { id: 'go', name: 'HeliosGO', price: '€90/month', status: 'locked', desc: 'GO сертифікати та CBAM-ready', trial: false, badge: 'HOT' },
];
